import { FileClient } from "clients/rest";

export type B100910ExcelRequest = {
  gamenId: string;
};

export const B100910GetExcel = (props: B100910ExcelRequest) => {
  return FileClient.get("b100910/get/excel", {
    params: props,
  });
};
